module.exports = __webpack_public_path__ + "img/53.65ae8fbe.jpg";